import { Box, Drawer, IconButton, Typography } from "@mui/material";

import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import { DrawerHeaderContainer } from "./DrawerHeaderContainer";
import { DrawerFooterContainer } from "./DrawerFooterContainer";
import { DrawerBodyContainer } from "./DrawerBodyContainer";

const CustomDrawer = ({
  open,
  anchor,
  overlapDrawer,
  drawerTitle,
  drawerBody,
  drawerBodyStyles,
  outSideClick,
  handleClose,
  handleBackArrowFn,
  headerCloseIcon,
}) => {
  return (
    <Drawer
      open={open}
      anchor={anchor}
      onClose={
        outSideClick ? (handleClose ? handleClose : undefined) : undefined
      }
      sx={{
        "& .MuiDrawer-paper": {
          width: "100%",
          "@media (min-width: 600px)": {
            width: "540px",
          },
        },
        "&.MuiDrawer-root>.MuiPaper-root.MuiPaper-elevation": {
          flexDirection: "column",
        },
      }}
    >
      {/* ==== drawer header start ==== */}
      <Box sx={{ background: "#fff", position: "sticky", top: 0, zIndex: 99 }}>
        <DrawerHeaderContainer>
          {!headerCloseIcon && (
            <IconButton
              className={overlapDrawer ? "StartButton" : "EndButton"}
              onClick={
                handleBackArrowFn
                  ? handleBackArrowFn
                  : handleClose
                  ? handleClose
                  : undefined
              }
            >
              {overlapDrawer ? (
                <ArrowBackRoundedIcon sx={{ color: "#0B132B" }} />
              ) : (
                <CloseRoundedIcon sx={{ color: "#0B132B" }} />
              )}
            </IconButton>
          )}
          <Typography>{drawerTitle}</Typography>
        </DrawerHeaderContainer>
      </Box>
      {/* ==== drawer header end ==== */}
      <DrawerBodyContainer sx={drawerBodyStyles}>
        {drawerBody}
      </DrawerBodyContainer>
      <DrawerFooterContainer>
        <Typography>
          This site is protected by reCAPTCHA and the Google&nbsp;
          <a href="https://policies.google.com/privacy" target="_blank">
            Privacy Policy
          </a>
          &nbsp;and&nbsp;
          <a href="https://policies.google.com/terms" target="_blank">
            Terms of Service
          </a>{" "}
          apply.
        </Typography>
      </DrawerFooterContainer>
    </Drawer>
  );
};

export default CustomDrawer;
